<template>
    <div></div>
</template>

<script>
import auth from 'services/auth';
// eslint-disable-next-line import/no-cycle
import { navigateToAngularRoute } from 'services/utils/angularRouterUtils';
import { mapMutations } from 'vuex';
import analytics from 'services/utils/analytics';

export default {
    name: 'LogOutPage',
    mounted() {
        this.setPage({
            pageTitle: 'Logout in Progress'
        });

        auth.logout();

        analytics.track('AccountLogout', 'logoutShowPage');

        navigateToAngularRoute('/');
        this.setPage({
            pageTitle: ''
        });
    },
    methods: {
        ...mapMutations([
            'setPage'
        ])
    }
};
</script>

<style lang="scss" scoped>
</style>
